(function (global) {
  'use strict';
  const labels = {
    trocken: 'Trocken', bruch: 'Strapaziert', fein: 'Fein & ohne Volumen', frizz: 'Frizz',
    locken: 'Lockig oder wellig', normal: 'Ausgeglichen / unsicher', natur: 'Naturhaar',
    gefaerbt: 'Gefärbt oder getönt', blondiert: 'Blondiert', gelbstich: 'Gelbstich',
    chemie: 'Chemisch umgeformt', unsicher: 'Unsicher', moisture: 'Feuchtigkeit',
    repair: 'Pflege für strapaziertes Haar', frizzSmoothing: 'Weniger Frizz', volume: 'Volumen',
    colorCare: 'Farbschutz', antiYellow: 'Gelbstich ausgleichen', curl: 'Locken definieren',
    stylingHold: 'Styling & Halt', hitzestyling: 'Föhn oder Glätteisen', finish: 'Stylingprodukte',
    wenig: 'Natürlich & unkompliziert', heatProtection: 'Hitzeschutz', cleansing: 'Reinigung',
  };
  const needs = {
    trocken: ['moisture'], bruch: ['repair'], fein: ['volume'], frizz: ['frizzSmoothing'],
    locken: ['curl'], normal: ['cleansing'], natur: [], gefaerbt: ['colorCare'],
    blondiert: ['repair'], gelbstich: ['antiYellow'], chemie: ['repair'], unsicher: [],
    hitzestyling: ['heatProtection'], finish: ['stylingHold'], wenig: [],
  };
  const groupRules = [
    ['cleansing', /shampoo|reinigung|cleansing/],
    ['conditioner', /conditioner|spulung|pflegespulung|balsam/],
    ['mask', /maske|mask\b|haarkur|treatment/],
    ['moisture', /feuchtigkeit|trocken|sprode|spr(o|oe)d|nahr|nahrend|argan|hydr|nutri|moistur/],
    ['repair', /repair|repar|keratin|protein|rekonstr|restruktur|regener|kraftlos|starkend|strapaziert|bond|plex/],
    ['frizzSmoothing', /frizz|glattung|glattende|glattendes|smooth|sleek/],
    ['volume', /volumen|volume|feines? haar|feinem haar|bodifying/],
    ['colorCare', /farbschutz|farberhalt|color save|color care|coloriertes|coloriertem|gefarbtes|gefarbtem/],
    ['antiYellow', /anti[- ]?gelb|gelbstich|silber|silver|no[- ]?yellow|anti[- ]?yellow/],
    ['curl', /locken|lockig|curl|wellig|wellen/],
    ['stylingHold', /haarspray|haargel|haarwachs|\bwachs\b|\bwax\b|pomade|fixierung|fixier|\bhalt\b|\bhold\b|styling|schaum|mousse/],
    ['heatProtection', /hitzeschutz|heat protection|thermoschutz/],
  ];
  const knownGroups = new Set(groupRules.map(([group]) => group));
  const roles = new Set(['Reinigung', 'Pflege', 'Hitzeschutz', 'Finish']);
  const rankOf = (product) => (Number.isFinite(product.rank) ? product.rank : Number.MAX_SAFE_INTEGER);
  const titleKey = (product) => normalize(product.title).replace(/[^a-z0-9]+/g, ' ').trim();
  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/ß/g, 'ss');
  }
  function productGroups(product) {
    // Groups from the catalog generator (title, product type, benefit tags)
    // stay valid when a title is reworded; the title rules are the fallback.
    if (Array.isArray(product.groups) && product.groups.length) {
      return product.groups.filter((group) => knownGroups.has(group));
    }
    // Product identity is stronger evidence than the legacy catch-all tags.
    const text = normalize(product.title);
    if (/entwickler|aktivator|activator|oxidations|blondierung|blondierpulver|dauerwell|farbentferner|cuticula|alkalin|neutralisator|neutralisierendes fixiermittel|glattungsmittel|glattungscreme|tonungscreme|tonungsfluid|haarf(a|ae)rb|\bhaarfarbe\b|farbcreme|color cream|colorcreme|permanent|\btoner\b/.test(text)) return [];
    if (product.caution === true && !/shampoo|maske|mask\b|conditioner|spulung|balsam|haarkur|haarol|pflegespray|hitzeschutz|haarspray|haarwachs|haargel/.test(text)) return [];
    return groupRules.filter(([, expression]) => expression.test(text)).map(([group]) => group);
  }
  function safeUrl(value) {
    const path = String(value || '');
    return /^\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(path) ? path : null;
  }
  function rankProducts(products, answers) {
    if (!answers.goal || !labels[answers.goal]) return [];
    const extra = Object.values(answers).flat().flatMap((value) => needs[value] || []);
    return products.map((product) => {
      const groups = productGroups(product);
      if (!safeUrl(product.url) || !groups.includes(answers.goal)) return null;
      if (groups.includes('antiYellow') && answers.goal !== 'antiYellow' && !(answers.treatment || []).includes('gelbstich')) return null;
      const named = Array.isArray(product.strong) && product.strong.includes(answers.goal) ? 3 : 0;
      return { ...product, groups, score: 100 + named - (product.bulk ? 6 : 0) + extra.reduce((sum, group) => sum + (groups.includes(group) ? 5 : 0), 0) };
    }).filter(Boolean).sort((a, b) => b.score - a.score || rankOf(a) - rankOf(b) || a.title.localeCompare(b.title, 'de'));
  }
  function productRole(product) {
    if (roles.has(product.role)) return product.role;
    const groups = productGroups(product);
    if (groups.includes('cleansing')) return 'Reinigung';
    if (groups.includes('conditioner') || groups.includes('mask') || /pflegelotion|ampull|haarol|serum|leave.in/.test(normalize(product.title))) return 'Pflege';
    if (groups.includes('heatProtection')) return 'Hitzeschutz';
    return 'Finish';
  }
  function selectProducts(products, limit = 3) {
    // Same product under two handles: show it once.
    const seen = new Set();
    const unique = products.filter((product) => {
      const keys = [product.url, titleKey(product)];
      if (keys.some((key) => seen.has(key))) return false;
      keys.forEach((key) => seen.add(key));
      return true;
    });
    const roles = new Set();
    const first = [];
    const alternatives = [];
    for (const product of unique) {
      const role = productRole(product);
      if (roles.has(role)) alternatives.push(product);
      else { roles.add(role); first.push(product); }
    }
    // A second care product helps more than a second shampoo.
    const preference = ['Pflege', 'Finish', 'Reinigung', 'Hitzeschutz'];
    const ordered = alternatives
      .map((product, index) => ({ product, index }))
      .sort((a, b) => preference.indexOf(productRole(a.product)) - preference.indexOf(productRole(b.product)) || a.index - b.index)
      .map(({ product }) => product);
    return [...first, ...ordered].slice(0, limit);
  }
  function resultSummary(answers) {
    const parts = [`Ausgewählt für dein Ziel: ${labels[answers.goal] || 'passende Pflege'}.`];
    if ((answers.state || []).includes('fein')) parts.push('Bei feinem Haar die Pflege sparsam dosieren.');
    else if ((answers.treatment || []).includes('blondiert')) parts.push('Blondierte Längen besonders schonend behandeln.');
    else if ((answers.styling || []).includes('hitzestyling')) parts.push('Beim Styling mit Hitze zusätzlich auf Hitzeschutz achten.');
    return parts.join(' ');
  }
  function routine(answers) {
    const result = ['Reinige dein Haar mit einem passenden Shampoo. Verteile die Pflege anschließend vor allem in Längen und Spitzen.'];
    const byGoal = {
      moisture: 'Nutze einen feuchtigkeitsspendenden Conditioner oder eine Maske nach Herstellerangabe. Beginne bei feinem Haar mit wenig Produkt.',
      repair: 'Wähle eine Pflege für strapaziertes Haar und reduziere belastende Hitze. Häufigkeit und Einwirkzeit richten sich nach dem Produkt.',
      frizzSmoothing: 'Verteile Anti-Frizz-Pflege sparsam in den Längen. Trockne das Haar schonend und vermeide kräftiges Trockenrubbeln.',
      volume: 'Wähle leichte Pflege und dosiere sie sparsam. Volumenprodukte kommen gezielt an den Ansatz oder in die vom Hersteller empfohlenen Haarpartien.',
      colorCare: 'Nutze Pflege für coloriertes Haar. Wasche möglichst schonend und beachte die Anwendungshinweise deiner Farb- und Pflegeprodukte.',
      antiYellow: 'Nutze pigmentierte Pflege nur entsprechend der Herstellerangabe. Prüfe bei porösem oder sehr hellem Haar zunächst die Wirkung an einer Strähne.',
      curl: 'Verteile die Lockenpflege gleichmäßig und forme deine Wellen oder Locken behutsam. Beginne mit einer kleinen Menge.',
      stylingHold: 'Beginne mit wenig Stylingprodukt und ergänze bei Bedarf. Passe die Menge an Haarlänge und gewünschten Halt an.',
    };
    if (byGoal[answers.goal]) result.push(byGoal[answers.goal]);
    result.push((answers.styling || []).includes('hitzestyling')
      ? 'Verwende vor Föhn oder Glätteisen einen dafür vorgesehenen Hitzeschutz und wähle eine möglichst niedrige, passende Temperatur.'
      : 'Lass dein Haar möglichst schonend trocknen. Ergänze nur so viel Finish, wie du für dein Styling brauchst.');
    return result;
  }
  function productUsage(product) {
    const groups = productGroups(product);
    const title = normalize(product.title);
    if (/leave[ -]?in|ohne ausspulen/.test(title)) return 'Sparsam in die vom Hersteller empfohlenen Haarpartien geben. Als Leave-in im Haar lassen; Menge und Anwendung richten sich nach der Packung.';
    if (groups.includes('cleansing')) return 'Im nassen Haar verteilen, sanft einmassieren und gründlich ausspülen. Beachte bei pigmentiertem Shampoo die Einwirkzeit auf der Packung.';
    if (groups.includes('mask')) return 'Nach der Haarwäsche in Längen und Spitzen verteilen. Nur eine der vorgeschlagenen Masken verwenden, nicht beide übereinander. Einwirkzeit, Häufigkeit und Ausspülen richten sich nach der Packungsanleitung.';
    if (groups.includes('conditioner')) return 'Nach dem Shampoo vor allem in Längen und Spitzen verteilen. Nach der auf der Packung angegebenen Einwirkzeit ausspülen, sofern dort nichts anderes steht.';
    if (productRole(product) === 'Hitzeschutz') return 'Vor dem Hitzestyling nach Packungsanleitung gleichmäßig verteilen. Ob das Produkt auf feuchtes oder trockenes Haar gehört, steht auf der Packung. Glätteisen nur im dafür geeigneten, trockenen Haar verwenden.';
    if (/haarol|serum/.test(title)) return 'Mit einer kleinen Menge in Längen und Spitzen beginnen. Ob das Produkt im Haar bleibt und auf feuchtes oder trockenes Haar gehört, richtet sich nach der Packung.';
    return 'Mit wenig Produkt beginnen und gleichmäßig in den auf der Packung genannten Haarpartien verteilen. Anwendung, Menge und ein mögliches Ausspülen nach Herstellerangabe wählen.';
  }
  function chooseRoutine(products, selectedIndex) {
    const selected = products[selectedIndex];
    const seen = new Set();
    return products.map((product) => {
      const role = productRole(product);
      const chosen = selected && role === productRole(selected) ? product === selected : !seen.has(role);
      seen.add(role);
      return { ...product, inRoutine: chosen };
    });
  }
  const routineProducts = (products) => products.filter((product) => product.inRoutine);
  async function addRoutineItems(items) {
    const drawer = global.document.querySelector('cart-drawer');
    const updates = global.drkallaCartUpdates;
    const ticket = updates?.begin();
    const payload = { items };
    if (drawer?.getSectionsToRender) {
      payload.sections = drawer.getSectionsToRender().map((section) => section.id);
      payload.sections_url = global.location.pathname;
      drawer.setActiveElement?.(global.document.activeElement);
    }
    try {
      const response = await global.fetch(global.routes?.cart_add_url || `${global.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      let state;
      try { state = await response.json(); } catch { state = {}; }
      if (!response.ok || Number(state?.status) >= 400) {
        throw new Error(state?.description || 'Das hat nicht geklappt. Bitte versuche es noch einmal oder öffne das Produkt.');
      }
      updates?.finish(ticket);
      // The theme subscribes to Dawn's cartUpdate, not the former cart:refresh event.
      // Its coordinator refreshes the full drawer and bubble from one current snapshot.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hair-guide', cartData: state }); } catch { /* refresh below remains authoritative */ }
      }
      if (updates) await updates.requestSync({ open: false, allowCached: true });
      else if (drawer?.renderContents) await drawer.renderContents(state, { open: false });
      return state;
    } finally { updates?.finish(ticket); }
  }
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  function restoreProgress(raw, allowed, now = Date.now()) {
    try {
      if (typeof raw !== 'string' || raw.length > 4096) return null;
      const saved = JSON.parse(raw);
      if (saved?.version !== 1 || !Number.isFinite(saved.at) || saved.at > now || now - saved.at > 30 * 60 * 1000) return null;
      if (!saved.answers || typeof saved.answers !== 'object' || !Number.isInteger(saved.step) || saved.step < 0 || saved.step > 3) return null;
      const values = {};
      for (const name of ['state','treatment','goal','styling']) {
        const entries = name === 'goal' ? [saved.answers[name]] : saved.answers[name];
        if (!Array.isArray(entries) || entries.some(value => typeof value !== 'string' || !allowed[name]?.includes(value))) return null;
        values[name] = name === 'goal' ? entries[0] : [...new Set(entries)];
      }
      const complete = Object.values(values).every(value => Array.isArray(value) ? value.length > 0 : Boolean(value));
      return { answers:values, step:saved.step, result:saved.result === true && complete };
    } catch { return null; }
  }
  global.DRKALLA_HAIR_GUIDE = { productGroups, rankProducts, safeUrl, routine, productRole, selectProducts, resultSummary, restoreProgress, productUsage, chooseRoutine, routineProducts, addRoutineItems };
  if (!global.document) return;

  // ---- UI (Redesign 20.10.2026): tiles, one-tap single choice, routine with cart buttons ----
  const FREE_SHIPPING_CENTS = 4900; // Germany, see shipping settings
  const ROLE_ORDER = ['Reinigung', 'Pflege', 'Hitzeschutz', 'Finish'];
  const ROLE_STEP = { Reinigung: 'Reinigen', Pflege: 'Pflegen', Hitzeschutz: 'Schützen', Finish: 'Stylen' };

  function init(root) {
    if (root.dataset.hairReady) return;
    root.dataset.hairReady = 'true';
    const find = (name) => root.querySelector(`[data-hair-${name}]`);
    const form = find('form');
    const steps = [...root.querySelectorAll('[data-hair-step]')];
    const result = find('result');
    let step = 0;
    let version = 0;
    let resumeResults = false;
    let shown = [];
    let cartBusy = false;
    const requests = new Set();
    let started = false;
    const progressKey = 'drkalla-hair-guide-progress-v1';
    const currency = () => global.Shopify?.currency?.active || 'EUR';
    const money = (amount) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency() }).format(amount);
    const track = (event, fields = {}) => {
      if (global.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && Array.isArray(global.dataLayer)) {
        global.dataLayer.push({ event, ...fields });
      }
    };
    // The newsletter popup checks this flag and stays closed once someone uses the analysis.
    const engage = () => { root.dataset.hairEngaged = 'true'; };
    root.addEventListener('pointerdown', engage, { once: true });
    root.addEventListener('focusin', engage, { once: true });
    const reducedMotion = () => global.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function answers() {
      const selected = (name) => [...form.querySelectorAll(`input[name="${name}"]:checked`)].map((input) => input.value);
      return { state: selected('state'), treatment: selected('treatment'), goal: selected('goal')[0] || '', styling: selected('styling') };
    }
    function saveProgress() {
      // Only selected answer IDs, never prices or contact details.
      try {
        const values = answers();
        if (!Object.values(values).some((value) => (Array.isArray(value) ? value.length : value))) global.sessionStorage.removeItem(progressKey);
        else global.sessionStorage.setItem(progressKey, JSON.stringify({ version: 1, at: Date.now(), answers: values, step, result: !result.hidden }));
      } catch { /* works without browser storage */ }
    }
    function showStep(index, focus = false) {
      step = Math.min(Math.max(index, 0), steps.length - 1);
      steps.forEach((element, i) => { element.hidden = i !== step; });
      find('step-count').textContent = `Frage ${step + 1} von ${steps.length}`;
      find('step-name').textContent = steps[step].dataset.title;
      find('progress').style.width = `${((step + 1) / steps.length) * 100}%`;
      [...(find('steps')?.children || [])].forEach((li, i) => {
        li.classList.toggle('is-done', i < step);
        li.classList.toggle('is-current', i === step);
      });
      find('back').hidden = step === 0;
      find('next').textContent = step === steps.length - 1 ? 'Meine Routine anzeigen' : 'Weiter';
      find('error').hidden = true;
      saveProgress();
      if (focus) {
        steps[step].querySelector('legend').focus({ preventScroll: true });
        const top = find('questions').getBoundingClientRect().top;
        if (top < 0 || top > global.innerHeight * 0.4) find('questions').scrollIntoView({ behavior: reducedMotion() ? 'instant' : 'smooth', block: 'start' });
      }
    }
    function cancelRequests() {
      version += 1;
      requests.forEach((controller) => controller.abort());
      requests.clear();
    }
    async function hydrate(product) {
      let path = safeUrl(product.url);
      if (!path) return null;
      const controller = new AbortController();
      requests.add(controller);
      const timeout = global.setTimeout(() => controller.abort(), 6000);
      try {
        const options = { signal: controller.signal, credentials: 'same-origin', mode: 'same-origin' };
        let response = await fetch(`${path.replace(/\/$/, '')}.js`, { ...options, headers: { Accept: 'application/json' } });
        if (response.status === 404) {
          // Shopify product redirects do not always apply to the Ajax .js endpoint.
          const destination = await fetch(path, options);
          const resolved = new URL(destination.url);
          await destination.body?.cancel();
          const redirectedPath = safeUrl(resolved.pathname);
          if (!destination.ok || resolved.origin !== global.location.origin || !redirectedPath || redirectedPath === path) return null;
          path = redirectedPath;
          response = await fetch(`${path.replace(/\/$/, '')}.js`, { ...options, headers: { Accept: 'application/json' } });
        }
        if (!response.ok) return null;
        const live = await response.json();
        if (live.available !== true || !Number.isFinite(live.price) || live.price < 0) return null;
        const variants = (Array.isArray(live.variants) ? live.variants : [])
          .filter((variant) => variant.available && Number.isFinite(variant.price))
          .map((variant) => {
            const measurement = variant.unit_price_measurement;
            return {
              id: variant.id,
              title: variant.title === 'Default Title' ? '' : variant.title,
              price: variant.price,
              taxable: variant.taxable !== false,
              unitPrice: Number.isFinite(variant.unit_price) && measurement?.reference_unit
                ? { amount: variant.unit_price / 100, reference: `${Number(measurement.reference_value) > 1 ? `${measurement.reference_value} ` : ''}${measurement.reference_unit}` }
                : null,
            };
          });
        if (!variants.length) return null;
        // Preselect the variant behind the shown (lowest) price.
        const preselected = variants.find((variant) => variant.price === live.price) || variants[0];
        return {
          ...product, url: path, title: live.title, minPrice: live.price / 100, available: true, variants, selected: preselected.id,
          image: typeof live.featured_image === 'string' ? live.featured_image : live.featured_image?.src || live.images?.[0],
        };
      } catch { return null; }
      finally { global.clearTimeout(timeout); requests.delete(controller); }
    }
    const variantOf = (product) => product.variants.find((variant) => variant.id === product.selected) || product.variants[0];
    function priceBlock(product) {
      const variant = variantOf(product);
      const tax = variant.taxable === false ? 'zzgl. Versand' : `inkl. ${currency() === 'EUR' ? '19 % ' : ''}MwSt., zzgl. Versand`;
      const unit = variant.unitPrice ? `Grundpreis ${money(variant.unitPrice.amount)} / ${variant.unitPrice.reference} · ` : '';
      return `<span class="dk-hq__price">${escape(money(variant.price / 100))}</span><span class="dk-hq__fine">${escape(unit + tax)}</span>`;
    }
    function card(product, index) {
      const role = productRole(product);
      const roleIndex = [...new Set(shown.map(productRole))].indexOf(role) + 1;
      const alternatives = shown.filter((entry) => productRole(entry) === role).length > 1;
      const image = typeof product.image === 'string' && /^(https:\/\/|\/\/)/.test(product.image)
        ? `<img src="${escape(product.image)}${product.image.includes('?') ? '&' : '?'}width=500" alt="" width="300" height="300" loading="lazy">` : '';
      const select = product.variants.length > 1
        ? `<select class="dk-hq__variant" data-hair-variant aria-label="Variante für ${escape(product.title)}">${product.variants.map((variant) => `<option value="${variant.id}"${variant.id === product.selected ? ' selected' : ''}>${escape(variant.title)} – ${escape(money(variant.price / 100))}</option>`).join('')}</select>`
        : '';
      return `<li class="dk-hq__item" data-hair-item="${index}"><article class="dk-hq__card">
        <p class="dk-hq__step"><b>${roleIndex}</b>${escape(ROLE_STEP[role] || role)}${alternatives ? ' · Auswahl' : ''}</p>
        <a class="dk-hq__img" href="${escape(product.url)}" tabindex="-1" aria-hidden="true">${image}</a>
        <div class="dk-hq__body">
          <a class="dk-hq__title" href="${escape(product.url)}">${escape(product.title)}</a>
          <div class="dk-hq__pricewrap" data-hair-price>${priceBlock(product)}</div>
          ${select}
          <p class="dk-hq__usage">${escape(productUsage(product))}</p>
          ${alternatives ? `<label class="dk-hq__routine-choice"><input type="radio" name="routine-${escape(root.id)}-${escape(role)}" aria-label="${escape(product.title)} für meine Routine auswählen" data-hair-choice${product.inRoutine ? ' checked' : ''}><span>Für meine Routine auswählen</span></label>` : ''}
          <div class="dk-hq__add"><button type="button" data-hair-add>In den Warenkorb</button><a href="${escape(product.url)}">Details</a></div>
        </div></article></li>`;
    }
    async function cartTotalCents() {
      try {
        const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        return (await response.json());
      } catch { return null; }
    }
    function updateBubble(cart) {
      const link = global.document.getElementById('cart-icon-bubble');
      if (!link || !cart) return;
      let bubble = link.querySelector('.cart-count-bubble');
      if (!bubble) {
        bubble = global.document.createElement('span');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        link.appendChild(bubble);
      }
      const count = cart.item_count;
      bubble.querySelector('[aria-hidden]').textContent = count < 100 ? String(count) : '99+';
      const hidden = bubble.querySelector('.visually-hidden');
      if (hidden) hidden.textContent = `${count} Artikel im Warenkorb`;
    }
    let cartCents = 0;
    function updateBundle() {
      const bundle = find('bundle');
      if (!shown.length) { bundle.hidden = true; return; }
      bundle.hidden = false;
      const selected = routineProducts(shown);
      const routineCents = selected.reduce((sum, product) => sum + variantOf(product).price, 0);
      const open = selected.filter((product) => !product.added).length;
      const allAdded = selected.every((product) => product.added);
      find('bundle-total').textContent = money(routineCents / 100);
      // The cart total includes everything already added, even a different alternative.
      const after = cartCents + selected.filter((product) => !product.added).reduce((sum, product) => sum + variantOf(product).price, 0);
      const share = Math.min(1, after / FREE_SHIPPING_CENTS);
      find('ship-bar').style.width = `${Math.round(share * 100)}%`;
      find('ship-text').textContent = after >= FREE_SHIPPING_CENTS
        ? (allAdded ? 'Dein Warenkorb erreicht den kostenlosen Versand innerhalb Deutschlands.' : 'Mit deiner Auswahl erreicht dein Warenkorb den kostenlosen Versand innerhalb Deutschlands.')
        : `Noch ${money((FREE_SHIPPING_CENTS - after) / 100)} bis zum kostenlosen Versand (Deutschland, ab 49 €).`;
      const button = find('add-all');
      button.textContent = allAdded ? 'Alles im Warenkorb ✓'
        : open === selected.length ? (selected.length > 1 ? `Ausgewählte Routine in den Warenkorb (${selected.length} Produkte)` : 'In den Warenkorb')
        : `Restliche ${open === 1 ? 'Produkt' : `${open} Produkte`} in den Warenkorb`;
      button.disabled = allAdded || cartBusy;
    }
    async function addToCart(products, source) {
      const items = products.map((product) => ({ id: variantOf(product).id, quantity: 1 }));
      await addRoutineItems(items);
      products.forEach((product) => { product.added = true; });
      const cart = await cartTotalCents();
      if (cart) { cartCents = cart.total_price; updateBubble(cart); }
      else cartCents += products.reduce((sum, product) => sum + variantOf(product).price, 0);
      global.document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      track('drkalla_hair_analysis_add_to_cart', { source, items: items.length, value: products.reduce((s, p) => s + variantOf(p).price, 0) / 100, currency: currency() });
      find('cart-status').innerHTML = `${products.length > 1 ? 'Deine Routine liegt' : 'Das Produkt liegt'} im Warenkorb. <a href="/cart">Zum Warenkorb</a>`;
      syncButtons();
      updateBundle();
    }
    function syncButtons() {
      find('edit').disabled = cartBusy;
      find('reset').disabled = cartBusy;
      root.querySelectorAll('[data-hair-item]').forEach((item) => {
        const product = shown[Number(item.dataset.hairItem)];
        const button = item.querySelector('[data-hair-add]');
        button.classList.toggle('is-added', Boolean(product?.added));
        button.textContent = product?.added ? 'Im Warenkorb ✓' : 'In den Warenkorb';
        button.disabled = cartBusy;
        item.classList.toggle('is-routine-selected', Boolean(product?.inRoutine));
        const choice = item.querySelector('[data-hair-choice]');
        if (choice) { choice.checked = Boolean(product?.inRoutine); choice.disabled = cartBusy; }
        const variant = item.querySelector('[data-hair-variant]');
        if (variant) variant.disabled = cartBusy;
      });
    }
    function renderRoutine() {
      const selected = routineProducts(shown);
      find('routine').innerHTML = selected.length
        ? selected.map((product) => `<li><strong>${escape(product.title)}</strong><br>${escape(productUsage(product))}</li>`).join('')
        : routine(answers()).map((line) => `<li>${escape(line)}</li>`).join('');
    }
    function chips(values) {
      const list = [...values.state, ...values.treatment, values.goal, ...values.styling].filter(Boolean).map((value) => labels[value]).filter(Boolean);
      find('chips').innerHTML = list.map((label) => `<li>${escape(label)}</li>`).join('');
    }
    async function heatProtectionPick(chosen) {
      // Heat stylers are told to use heat protection; show one that is in stock.
      const taken = new Set(chosen.map((product) => product.url));
      const pool = (global.DRKALLA_HAIR_ANALYSIS?.products || [])
        .filter((product) => productGroups(product).includes('heatProtection') && !taken.has(product.url))
        .sort((a, b) => Number(Array.isArray(b.strong) && b.strong.includes('heatProtection')) - Number(Array.isArray(a.strong) && a.strong.includes('heatProtection')) || rankOf(a) - rankOf(b));
      for (const product of pool.slice(0, 4)) {
        const live = await hydrate(product);
        if (live) return { ...live, role: 'Hitzeschutz' };
      }
      return null;
    }
    async function recommend({ restoring = false } = {}) {
      const values = answers();
      cancelRequests();
      shown = [];
      const currentVersion = version;
      find('questions').hidden = true;
      result.hidden = false;
      saveProgress();
      find('result-title').textContent = `Deine Routine: ${labels[values.goal]}`;
      find('result-summary').textContent = resultSummary(values);
      chips(values);
      find('routine').innerHTML = routine(values).map((line) => `<li>${escape(line)}</li>`).join('');
      find('products').innerHTML = '';
      find('bundle').hidden = true;
      find('cart-status').textContent = '';
      find('products').setAttribute('aria-busy', 'true');
      find('product-status').textContent = 'Wir stellen deine Routine zusammen …';
      if (!restoring) {
        result.scrollIntoView({ behavior: reducedMotion() ? 'instant' : 'smooth', block: 'start' });
        find('result-title').focus({ preventScroll: true });
      }
      let unique = [];
      let heat = null;
      try {
        const ranked = rankProducts(global.DRKALLA_HAIR_ANALYSIS?.products || [], values);
        const candidates = selectProducts(ranked, ranked.length);
        const available = [];
        for (let i = 0; i < candidates.length && available.length < 3; i += 4) {
          const batch = await Promise.all(candidates.slice(i, i + 4).map(hydrate));
          if (currentVersion !== version) return;
          available.push(...rankProducts(batch.filter(Boolean), values));
        }
        if (currentVersion !== version) return;
        unique = selectProducts(available);
        if ((values.styling || []).includes('hitzestyling') && !unique.some((product) => productRole(product) === 'Hitzeschutz')) {
          heat = await heatProtectionPick(unique);
          if (currentVersion !== version) return;
        }
      } catch {
        if (currentVersion !== version) return;
        unique = [];
        heat = null;
      }
      shown = chooseRoutine([...unique, ...(heat ? [heat] : [])]
        .map((product, index) => ({ product, index }))
        .sort((a, b) => ROLE_ORDER.indexOf(productRole(a.product)) - ROLE_ORDER.indexOf(productRole(b.product)) || a.index - b.index)
        .map(({ product }) => ({ ...product, added: false })));
      const list = find('products');
      list.dataset.count = String(shown.length);
      list.innerHTML = shown.map(card).join('');
      syncButtons();
      renderRoutine();
      list.removeAttribute('aria-busy');
      find('product-status').textContent = shown.length
        ? `${routineProducts(shown).length} Pflegestufen für dich, alle Produkte sofort lieferbar.${shown.length > routineProducts(shown).length ? ' Pro Schritt wählst du ein Produkt. Die weiteren Vorschläge sind Alternativen.' : ''}`
        : 'Aktuell konnten wir kein passendes verfügbares Produkt bestätigen. Unsere persönliche Beratung hilft dir gerne bei der Auswahl.';
      const cart = await cartTotalCents();
      if (currentVersion !== version) return;
      cartCents = cart?.total_price || 0;
      updateBundle();
      if (!restoring) track('drkalla_hair_analysis_completed', { product_count: shown.length });
    }
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!steps[step].querySelector('input:checked')) {
        find('error').textContent = 'Bitte wähle eine Antwort aus, damit wir deine Routine passend zusammenstellen können.';
        find('error').hidden = false;
        steps[step].querySelector('input').focus();
        return;
      }
      track('drkalla_hair_analysis_step_completed', { step: step + 1 });
      if (step < steps.length - 1) showStep(step + 1, true);
      else void recommend();
    });
    let autoTimer = null;
    form.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.matches('input')) return;
      engage();
      if (!started) { started = true; track('drkalla_hair_analysis_started'); }
      if (input.checked) {
        const exclusive = { state: ['normal'], treatment: ['natur', 'unsicher'], styling: ['wenig'] };
        const exclusions = exclusive[input.name] || [];
        form.querySelectorAll(`input[name="${input.name}"]`).forEach((other) => {
          if (other !== input && (exclusions.includes(input.value) || exclusions.includes(other.value))) other.checked = false;
        });
      }
      find('error').hidden = true;
      saveProgress();
      // Single choice: one tap moves on.
      if (input.type === 'radio' && input.checked && input.closest('[data-hair-step]') === steps[step]) {
        global.clearTimeout(autoTimer);
        autoTimer = global.setTimeout(() => form.requestSubmit(), reducedMotion() ? 0 : 280);
      }
    });
    find('products').addEventListener('change', (event) => {
      const choice = event.target.closest('[data-hair-choice]');
      if (choice) {
        const selectedIndex = Number(choice.closest('[data-hair-item]').dataset.hairItem);
        const selectedRole = productRole(shown[selectedIndex]);
        shown.forEach((product, index) => { if (productRole(product) === selectedRole) product.inRoutine = index === selectedIndex; });
        syncButtons(); renderRoutine(); updateBundle();
        return;
      }
      const select = event.target.closest('[data-hair-variant]');
      if (!select) return;
      const item = select.closest('[data-hair-item]');
      const product = shown[Number(item.dataset.hairItem)];
      product.selected = Number(select.value);
      product.added = false;
      item.querySelector('[data-hair-price]').innerHTML = priceBlock(product);
      syncButtons();
      updateBundle();
    });
    find('products').addEventListener('click', async (event) => {
      const button = event.target.closest('[data-hair-add]');
      const item = event.target.closest('[data-hair-item]');
      if (!item) return;
      const index = Number(item.dataset.hairItem);
      if (!button) {
        if (event.target.closest('a')) track('drkalla_hair_analysis_product_clicked', { position: index + 1 });
        return;
      }
      const product = shown[index];
      if (product.added) { global.location.href = '/cart'; return; }
      if (cartBusy) return;
      // Adding an alternative individually also makes it the choice for this step.
      shown.forEach((entry) => { if (productRole(entry) === productRole(product)) entry.inRoutine = entry === product; });
      renderRoutine();
      cartBusy = true;
      syncButtons(); updateBundle();
      button.disabled = true;
      button.textContent = 'Wird hinzugefügt …';
      try { await addToCart([product], 'single'); }
      catch (error) { find('cart-status').textContent = error.message; button.textContent = 'In den Warenkorb'; }
      finally { cartBusy = false; syncButtons(); updateBundle(); }
    });
    find('add-all').addEventListener('click', async () => {
      const open = routineProducts(shown).filter((product) => !product.added);
      if (!open.length || cartBusy) return;
      cartBusy = true;
      syncButtons();
      const button = find('add-all');
      button.disabled = true;
      button.textContent = 'Wird hinzugefügt …';
      try { await addToCart(open, 'routine'); }
      catch (error) { find('cart-status').textContent = error.message; button.disabled = false; updateBundle(); }
      finally { cartBusy = false; syncButtons(); updateBundle(); }
    });
    const saveConsultation = () => {
      global.DRKALLA_HAIR_CONTACT?.save(answers(), routineProducts(shown), labels);
    };
    find('contact')?.addEventListener('click', saveConsultation);
    find('contact')?.addEventListener('auxclick', saveConsultation);
    find('back').addEventListener('click', () => showStep(step - 1, true));
    find('edit').addEventListener('click', () => {
      cancelRequests(); result.hidden = true; find('questions').hidden = false; showStep(0, true);
    });
    find('reset').addEventListener('click', () => {
      cancelRequests(); form.reset(); result.hidden = true; started = false; shown = [];
      find('questions').hidden = false; showStep(0, true);
    });
    global.addEventListener('pagehide', () => {
      resumeResults = !result.hidden;
      saveProgress();
      cancelRequests();
    });
    global.addEventListener('pageshow', (event) => {
      if (event.persisted && resumeResults && !result.hidden) {
        resumeResults = false;
        void recommend({ restoring: true });
      }
    });
    let saved;
    try {
      const allowed = Object.fromEntries(['state', 'treatment', 'goal', 'styling'].map((name) =>
        [name, [...form.querySelectorAll(`input[name="${name}"]`)].map((input) => input.value).concat(name === 'goal' ? [''] : [])]));
      saved = restoreProgress(global.sessionStorage.getItem(progressKey), allowed);
    } catch { saved = null; }
    if (saved) {
      for (const input of form.querySelectorAll('input[type="checkbox"],input[type="radio"]')) {
        input.checked = [saved.answers[input.name]].flat().includes(input.value);
      }
      started = true;
      engage();
    }
    showStep(saved?.step || 0);
    if (saved?.result) void recommend({ restoring: true });
  }
  function initialize() { global.document.querySelectorAll('[data-hair-guide]').forEach(init); }
  if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  global.document.addEventListener('shopify:section:load', initialize);
})(typeof window !== 'undefined' ? window : globalThis);
